import { FiExternalLink, FiPaperclip, FiSmile } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import { IoPersonCircle } from "react-icons/io5";
import { BsThreeDotsVertical } from "react-icons/bs";



const AIEmailView = ({ email }) => {
  return (
    <div className="flex w-full h-full max-h-screen overflow-y-auto p-2 sm:p-4">
  <div className="w-full mx-auto p-4 sm:p-6 bg-white shadow-md rounded-lg overflow-y-auto max-h-[90vh]">
    {/* Header */}
    <div className="flex items-center mb-4">
      <h2 className="text-gray-900 text-lg font-semibold">Summary</h2>
    </div>

    {/* Summary */}
    <p className="text-gray-700 text-sm font-medium mb-4 flex-wrap w-full sm:w-4/5">
      {email?.summary}
    </p>

    {/* Critical Points */}
    {email?.criticalPoints?.length > 0 && (
      <>
        <h3 className="text-gray-900 font-semibold mb-2">Critical Points</h3>
        <ul className="list-disc list-inside text-gray-700 text-sm mb-4">
          {email.criticalPoints.map((point, index) => {
            const formattedText = point.replace(/\*(.*?)\*/g, "<strong>$1</strong>");
            return (
              <p
                key={index}
                className="px-3 mb-1 py-1 w-fit text-sm bg-gray-200 rounded hover:bg-gray-300"
                dangerouslySetInnerHTML={{ __html: formattedText }}
              />
            );
          })}
        </ul>
      </>
    )}

    {/* Action Items */}
    {email?.actionItems?.length > 0 && (
      <>
        <h3 className="text-gray-900 font-semibold mb-2">Actions</h3>
        <div className="flex flex-col gap-2">
          {email.actionItems.map((action, index) => (
            <div key={index}>
              <button className="px-3 mb-1 py-1 w-fit text-sm bg-gray-200 text-gray-700 rounded hover:bg-gray-300">
                {action?.task}
              </button>
              {/* Uncomment to show applications
              {action.applications?.map((application, i) => (
                <button key={i} className="px-3 mb-1 ml-2 py-1 w-fit text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200">
                  {application}
                </button>
              ))} */}
            </div>
          ))}
        </div>
      </>
    )}
  </div>
</div>
    

  );
};

export default AIEmailView;